module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-10.36c69f8f.png";